import { z } from "zod";
import { emailSchema } from "../common/index.js";

export const googleTokenPayloadSchema = z.object({
	sub: z.string(),
	email: emailSchema,
	email_verified: z.boolean().optional().default(false),
	given_name: z.string().optional(),
	family_name: z.string().optional(),
	picture: z.string().optional(),
});

export type GoogleTokenPayload = z.infer<typeof googleTokenPayloadSchema>;
